import { Divider, Drawer, Grid, Typography } from '@material-ui/core';
import { CadastroCriApiRequest } from 'common/genericTypes';
import UploadDocs, { Attachment } from 'components/uploadDocs';
import { Button, DatePicker, MdSpace, SmSpace } from 'm2m.components';
import { Dispatch, SetStateAction, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { dataAditamento } from 'store/modules/cri/aditamento';
import CriParser from 'utils/parsers/criParser';
import { addAlert } from 'store/modules/snackBar';

export function FormularioDrawerAditamento({
  open,
  setOpen,
  handleSubmit,
  codigo,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleSubmit: () => void;
  codigo: string;
}) {
  const dispatch = useDispatch();
  const [documento, setDocumento] = useState<File | undefined>();

  const caracteristicas = useSelector((state: RootState) => state.criCadastro.caracteristicas);
  const criteriosRemuneracao = useSelector((state: RootState) => state.criCadastro.criteriosRemuneracao);
  const eventos = useSelector((state: RootState) => state.criCadastro.eventos);
  const uploadDocumentos = useSelector((state: RootState) => state.criCadastro.uploadDocumentos);
  const emissor = useSelector((state: RootState) => state.criCadastro.emissor);
  const criId = useSelector((state: RootState) => state.criCadastro.caracteristicas.id);
  const dateAditamento = useSelector((state: RootState) => state.criCadastro.dataAditamento);

  const criApi = useSelector((state: RootState) => state.criApi);

  const handleUpdateFileToStore = (attachments: Attachment[]): void => {
    const newAttachment = attachments?.[0].file;
    setDocumento(newAttachment);
  };

  const submitPutCriAditamento = async (
    criId: string,
    cri: CadastroCriApiRequest,
    file: File
  ): Promise<string> => {
    try {
      if (typeof dateAditamento !== 'undefined') {
        return await criApi.putCriAditamento(
          dispatch,
          criId,
          cri,
          dateAditamento,
          file,
          true
        );
      } else throw 'Falta informações a serem aditadas';
    } catch (error: any) {
      console.log(error);
      dispatch(addAlert({ message: error, severity: 'error' }));
    }
    return codigo;
  };

  const handleAditamentoSubmit = async (): Promise<string | (() => void)> => {
    try {
      const cri: CadastroCriApiRequest = CriParser.stateToCadastroCriApiRequest(
        caracteristicas,
        criteriosRemuneracao,
        eventos,
        uploadDocumentos,
        emissor
      );
      if (!criId) throw 'Erro ao aditar.';
      let criResponse;

      if (documento) {
        criResponse = await submitPutCriAditamento(criId, cri, documento);
        if (!criResponse || criResponse.length === 0) throw 'Erro ao aditar';

        dispatch(addAlert({ message: criResponse, severity: 'success' }));
        handleSubmit();
      }
      if (!criResponse) throw 'Erro ao aditar';

      return criResponse;
    } catch (error: any) {
      dispatch(addAlert({ message: error.message, severity: 'error' }));

      throw error;
    }
  };

  const handleUpdateDataAditamento = (input: string | undefined): void => {
    dispatch(dataAditamento(input));
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{ style: { padding: '40px', maxWidth: 460 } }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h3">{'Aditamento'}</Typography>
          <SmSpace />
          <Divider variant="fullWidth" />
          <MdSpace />
          <Typography variant="body2">{`Tem certeza que deseja solicitar aditamento do instrumento ${codigo}?`}</Typography>
          <SmSpace />
          <DatePicker
            value={undefined}
            label="Data do aditamento"
            onChange={(value) => handleUpdateDataAditamento(value?.format())}
          />
          <SmSpace />
          <UploadDocs
            aditamento={true}
            multipleFiles={false}
            inputAttachments={[]}
            onChange={handleUpdateFileToStore}
          />
          <MdSpace />
          <Button
            onClick={handleAditamentoSubmit}
            disabled={typeof documento === 'undefined'}
            variant="contained"
            color="primary"
            fullWidth
          >
            {'Solicitar Aditamento'}
          </Button>
          <SmSpace />
          <Button onClick={() => setOpen(false)} variant="contained" color="error" fullWidth>
            {'Cancelar'}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
}
